import WarningTriangleIcon from '@assets/images/warning-triangle.svg?react'
import Typography from '@/ui/components/typography'
import { LabelContainer } from './Label.styles'
import { LabelProps } from './Label.types'
import { useCustomTheme } from '@/core/theme'

const Label = ({
    title,
    variant = 'warning',
    textColor,
    dataTestId,
}: LabelProps) => {
    const theme: any = useCustomTheme()
    const showIcon = variant === 'warning'

    return (
        <LabelContainer variant={variant}>
            {showIcon && <WarningTriangleIcon width={20} height={20} />}
            <Typography
                color={textColor ?? theme.colors.greys[700]}
                variant="xs-bold"
                testId={dataTestId}
            >
                {title}
            </Typography>
        </LabelContainer>
    )
}

export default Label
